export default __webpack_public_path__ + "static/media/convenio.0e2706e5.pdf";